import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Advice } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const MailChimpNotExported = ({ notExportedCount }) => (
    <div className="fm-mailchimp-not-exported">
        <Advice
            className="fm-mailchimp-not-exported__advice"
            showCollapse={false}
            showIcon
            type="error"
        >
            {getLiteral('label_mailchimp_error_exported_emails')} ({notExportedCount})
        </Advice>
    </div>
);

MailChimpNotExported.propTypes = {
    notExportedCount: PropTypes.number,
};

export default memo(MailChimpNotExported);
